import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFix = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m24.724 26.6 1.815-1.69c.192-.193.288-.406.288-.64 0-.233-.096-.447-.288-.64l-6.27-6.27c.137-.384.247-.755.33-1.113.082-.357.123-.729.123-1.114 0-1.595-.563-2.956-1.69-4.083-1.128-1.128-2.49-1.692-4.085-1.692-.467 0-.934.07-1.402.207-.467.137-.921.33-1.361.577l3.63 3.589-2.228 2.104-3.547-3.507a5.618 5.618 0 0 0-.743 2.805c0 1.568.55 2.895 1.65 3.981 1.1 1.086 2.434 1.63 4.002 1.63.384 0 .763-.035 1.134-.104.371-.068.75-.172 1.134-.31l6.229 6.27a.865.865 0 0 0 .64.248.865.865 0 0 0 .639-.247ZM18 34.563c-2.255 0-4.386-.433-6.394-1.3a16.734 16.734 0 0 1-5.26-3.547 16.736 16.736 0 0 1-3.547-5.26C1.933 22.449 1.5 20.318 1.5 18.063c0-2.282.433-4.427 1.3-6.435.866-2.007 2.048-3.754 3.547-5.239 1.499-1.485 3.252-2.66 5.26-3.526 2.007-.867 4.138-1.3 6.393-1.3 2.282 0 4.427.433 6.435 1.3 2.008.866 3.754 2.041 5.239 3.526 1.485 1.485 2.66 3.232 3.527 5.24.866 2.007 1.299 4.152 1.299 6.434 0 2.255-.433 4.386-1.3 6.394-.866 2.007-2.041 3.76-3.526 5.26-1.485 1.498-3.232 2.68-5.239 3.547-2.008.866-4.152 1.3-6.435 1.3Zm0-2.475c3.905 0 7.219-1.368 9.941-4.104 2.723-2.736 4.084-6.043 4.084-9.92 0-3.906-1.361-7.22-4.084-9.942C25.22 5.398 21.905 4.037 18 4.037c-3.877 0-7.184 1.361-9.92 4.084-2.737 2.722-4.105 6.036-4.105 9.941 0 3.878 1.368 7.185 4.104 9.92 2.737 2.737 6.043 4.105 9.921 4.105Z",
		fill: "current-color"
	})]
});
const ForwardRef = forwardRef(SvgFix);
export { ForwardRef as ReactComponent };
